import $ from 'jquery'
import Backbone from 'backbone'
import selectize from 'scoreboard-select'
import * as d3 from 'd3-selection'
import _ from 'lodash'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import i18n from 'scoreboard/components/i18n'

var MultiSelector = Backbone.View.extend({

	className: 'multi-selector',

	events: {
		'change': 'change'
	},

	/**
	 * @param {Boolean} [options.uniqueResults] True if the the values in this selector should be unique
	 * to one another, else false.
	 * @param {Boolean} [options.required] True if this input is required, else false.
	 */
	initialize: function (options = {}) {
		this.options = options
		this.uniqueResults = _.isNil(this.options.uniqueResults) ? true : this.options.uniqueResults
		this.$el.data('view', this)
		this._setupControl()
		this._setupListeners()
	},

	// Used to create the controls which are to be used to pass values to this
	// selector (ex. DateTimeSelector)
	_setupControl() {},
	// Setup relevant listeners after all parts of the selector have been created.
	_setupListeners() {},

	// A lot of calling code is interacting with just the `selectedOptions` of this object, so if someone
	// removes an option (e.g. by clicking the X on the tag), we need to make sure it's removed from selectedOptions
	change: function () {
		_.remove(this.selectOptions, option => !option.selected) // remove any options that are no longer selected
	},

	render: function() {
		this.$el.addClass(this.className)
		this.renderSelect(false)
		if (this.options.required) {
			this.markedField = new MarkedField({
				el: this.el,
				validator: requiredValidator
			}).render()
			// use the val implementation from this class instead of the
			// MarkedField.  This is needed so we can handle equations properly
			// in EquationAndMultiSelector
			this.markedField.val = () => this._val()
		}
		return this
	},

	renderSelect: function (open) {
		var self = this

		var drawSelect = open => {
			selectize(this.el, {
				filter: () => null, // placeholders only appear for filter selects
				multiple: true,
				open,
				changeableTags: true,
				options: this.selectOptions,
				placeholder: i18n.get('common.startTyping'),
				render: {
					resultset: args => this._resultset(args)
				}
			})
		}

		drawSelect(open)

		d3.select(this.el.nextSibling)
			.select('.select-control')
			.on('mousedown', (e, d) => {
				// They are clicking outside of an active tag, somewhere in the select-control.
				// We know it's not on a tag b/c the tag event handler from the scoreboard-select could
				// would have handled the event. We want to make sure the dropdown opens so they can add a new select,
				// so make sure no options are active
				// See #20017
				d.options.forEach(opt => delete opt.active)
				drawSelect(true)
			})

		d3.select(this.el.nextSibling)
			.select('textarea').on('focus', function (e, data) {
				if (self.markedField) {
					// Update .has-menu on the markedField's .select so that it knows to
					// handle the blur event appropriately #20016 (marked-field.js:_onBlur())
					self.markedField.$('.select').toggleClass('has-menu', data.open)
				}
			})
	},

	activeTag: function () {
		return d3.select(this.el.nextSibling).datum().options.find(d => {
			return d.active
		})
	},

	// Fire a `change` event on the native select so change event listeners fire.
	// Normally the scoreboard-select code handles this on `change:selected` events, but since we're handling
	// the events in the dropdown menu and whatever component is in there,
	// we need to do trigger this manually
	_triggerSelectEvent() {
		var e = document.createEvent('Event')
		e.initEvent('change', true, true)
		e._rich = true // Set so the rich select thinks it triggered this event and doesn't re-render
		this.el.dispatchEvent(e)
	},

	_resultset() {},
	_val() {},
	_compareResults(oldVal, newVal) {},

	// If the select should be unique in this selector and this newly clicked
	// option has already been accepted, reject it and highlight the existing option
	_rejectDuplicates(newVal) {
		if (this.uniqueResults) {
			for (let i = 0; i < this.selectOptions.length; i++) {
				if (this._compareResults(this.selectOptions[i].value, newVal)
					&& this.selectOptions[i].selected) {
					// We need to highlight the select option we just found
					this.$el.siblings('.select').find('.item').each((index, item) => {
						if (this.selectOptions[i].label == item.innerText) {
							$(item).on('transitionend', ()  => {
								$(item).removeClass('is-spotlighted')
							})
							$(item).addClass('is-spotlighted')
						}
					})
					return true
				}
			}
		}
	},

	remove: function() {
		_.invokeMap([this.markedField], 'remove')
		Backbone.View.prototype.remove.apply(this, arguments)
	}

})

export default MultiSelector

MultiSelector.__filename__ = 'components/multi-selector.js'
